import React from 'react';

const SvgStripeIcon = () => (
    <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M4.987 5.36C4.987 4.589 5.617 4.292 6.662 4.292C7.774 4.292 9.104 4.543 10.328 5.004C10.895 5.218 11.55 4.822 11.55 4.215V1.588C11.5532 1.38845 11.4935 1.19294 11.3794 1.02924C11.2652 0.865533 11.1024 0.741941 10.914 0.676C9.494 0.195 8.086 0 6.662 0C2.661 0 0 2.097 0 5.598C0 11.058 7.49 10.187 7.49 12.541C7.49 13.451 6.702 13.747 5.598 13.747C4.343 13.747 2.821 13.351 1.433 12.757C0.873 12.517 0.217 12.909 0.217 13.517V16.215C0.217 16.615 0.453 16.978 0.827 17.119C2.459 17.734 4.09 18 5.597 18C9.697 18 12.516 15.963 12.516 12.422C12.496 6.527 4.986 7.576 4.986 5.36H4.987Z" fill="#695DFF"/>
    </svg>
);

export default SvgStripeIcon;
